import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryConstants } from '../../commons/constants';
import { QueryStatus } from '../../commons/components/QueryStatus';

export const useFetchedSurvey = () => {
  const { businessPlanApi } = useApi();
  const queryCacheManager = useQueryCacheManager();
  const queryKey = queryCacheManager.getBusinessPlanCacheKey();
  const query = useQuery(queryKey, async () => businessPlanApi.getBusinessPlanSurvey(), {
    staleTime: ReactQueryConstants.businessPlanStaleTime,
    refetchInterval: ReactQueryConstants.businessPlanRefetchInterval,
  });
  const queryStatusComponent = (
    <QueryStatus
      queryKey={queryKey}
      queryStatus={query.status}
      dataTestPrefix="business-plan"
      failedToLoadText="Something went wrong while loading the business plan."
    />
  );

  return { query, queryStatusComponent };
};
